import { render, staticRenderFns } from "./HighNetWorthDataTable.vue?vue&type=template&id=0a2471b2&scoped=true"
import script from "./HighNetWorthDataTable.vue?vue&type=script&lang=js"
export * from "./HighNetWorthDataTable.vue?vue&type=script&lang=js"
import style0 from "./HighNetWorthDataTable.vue?vue&type=style&index=0&id=0a2471b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2471b2",
  null
  
)

export default component.exports